import { render, staticRenderFns } from "./ArticleInfoMultimedijaTemplate.vue?vue&type=template&id=4e212a59&scoped=true"
import script from "./ArticleInfoMultimedijaTemplate.vue?vue&type=script&lang=ts"
export * from "./ArticleInfoMultimedijaTemplate.vue?vue&type=script&lang=ts"
import style0 from "./ArticleInfoMultimedijaTemplate.vue?vue&type=style&index=0&id=4e212a59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e212a59",
  null
  
)

export default component.exports